import axios from "axios";
import { APIHOSTNOW } from "@/config";
axios.defaults.baseURL = APIHOSTNOW;
const boardlist = async () => {
    const response = await axios.get("/board");
    return response.data;
};
export default {
    boardlist,
};
